import React from 'react';
import { useIntl } from 'react-intl';

import { Formik } from 'formik';
import moment from 'moment';

import CommonFormikDialog from 'components/Shared/CommonFormikDialog';
import CertificateDialogView from '../FormViews/CertificateDialogView';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import MomentUtils from '@date-io/moment';
import { addUtcOffset } from 'utils/formatTimes';
import {
    validateRequiredFields,
    validateInputLength,
    validateUrlAddress,
    validateDateFields,
} from 'utils/formValidations';

import { TITLE_MAX_LENGTH } from './CertificateDialogConstants';

import { ReactComponent as InfoIcon } from "assets/info-icon.svg";

const CertificateDialog = ({
    open,
    onClose,
    onSubmit,
    selectedItem,
}) => {
    const intl = useIntl();

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <Formik
                enableReinitialize
                initialValues={{
                    title: selectedItem?.title || '',
                    documentUrl: selectedItem?.documentUrl || '',
                    issueDate: selectedItem?.issueDate ? moment.utc(selectedItem?.issueDate) : null,
                }}
                validate={values => {
                    return {
                        ...validateRequiredFields(values, ['title']),
                        ...validateInputLength(values, [{ property: 'title', maxLength: TITLE_MAX_LENGTH }]),
                        ...validateUrlAddress(values, 'documentUrl', true),
                        ...validateDateFields(values, ['issueDate']),
                    }
                }}

                onSubmit={(values) => {
                    const { title, documentUrl, issueDate } = values;

                    const entry = { title, documentUrl, issueDate: addUtcOffset(issueDate) };

                    selectedItem
                        ? onSubmit({ ...selectedItem, ...entry }, selectedItem?.index)
                        : onSubmit(entry);

                    onClose();
                }}
            >
                {(props) => (
                    <CommonFormikDialog
                        size="sm"
                        className="certificate-dialog"
                        dialogTitle={intl.formatMessage({ id: "add-certificate" })}
                        saveBtnText="save"
                        discardBtnText="discard"
                        open={open}
                        onClose={onClose}
                        onSave={props.handleSubmit}
                    >
                        <p className="hint"><InfoIcon/>{intl.formatMessage({ id: 'not-permanent-save-helper-text' })}</p>
                        <CertificateDialogView {...props} />
                    </CommonFormikDialog>
                )}
            </Formik>
        </MuiPickersUtilsProvider>
    );
};

export default CertificateDialog;
